<template>
    <v-dialog v-model="dialog" max-width="800px">
        <v-card>
            <v-card-title class="headline">
                Datos del Proveedor
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form ref="form">
                    <h3 class="mb-3">Generales</h3>
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-autocomplete label="Régimen fiscal" :items="regimenes" v-model="form.regimen_fiscal"
                                outlined dense />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.contacto" label="Contacto" outlined dense />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.direccion" label="Dirección" outlined dense />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.telefono" label="Teléfono" outlined dense />
                        </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <h3 class="mb-3">Bancarios</h3>
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-select v-model="form.banco_id" :items="bancos" item-text="nombre" item-value="id"
                                label="Banco" outlined dense />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.cuenta" label="Cuenta" outlined dense />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.referencia" label="Referencia" outlined dense />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.clabe" label="CLABE" outlined dense />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.swift" label="SWIFT" outlined dense />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-btn text @click="close">Cancelar</v-btn>
                <v-btn color="primary" @click="guardar">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "GeneralUserForm",
    props: {
        value: { type: Boolean, default: false }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    data() {
        return {
            form: {
                regimen_fiscal: "",
                contacto: "",
                direccion: "",
                telefono: "",
                banco_id: null,
                cuenta: "",
                referencia: "",
                clabe: "",
                swift: ""
            },
            bancos: [],
            regimenes: [
                "General de Ley Personas Morales",
                "Personas Morales con Fines no Lucrativos",
                "Sueldos y Salarios e Ingresos Asimilados a Salarios",
                "Arrendamiento",
                "Régimen de Enajenación o Adquisición de Bienes",
                "Demás ingresos",
                "Consolidación",
                "Residentes en el Extranjero sin Establecimiento Permanente en México",
                "Ingresos por Dividendos (socios y accionistas)",
                "Personas Físicas con Actividades Empresariales y Profesionales",
                "Ingresos por intereses",
                "Régimen de los ingresos por obtención de premios",
                "Sin obligaciones fiscales",
                "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
                "Incorporación Fiscal",
                "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
                "Opcional para Grupos de Sociedades",
                "Coordinados",
                "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
                "Régimen Simplificado de Confianza",
                "Hidrocarburos",
                "De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales",
                "Enajenación de acciones en bolsa de valores"
            ]
        };
    },
    watch: {
        dialog(val) {
            if (val) {
                this.form = {
                    regimen_fiscal: this.user.regimen_fiscal || "",
                    contacto: this.user.contacto || "",
                    direccion: this.user.direccion || "",
                    telefono: this.user.telefono || "",
                    banco_id: this.user.banco_id || null,
                    cuenta: this.user.cuenta || "",
                    referencia: this.user.referencia || "",
                    clabe: this.user.clabe || "",
                    swift: this.user.swift || ""
                };
            }
        }
    },
    mounted() {
        this.getBancos();
    },
    methods: {
        async guardar() {
            try {
                const URL = `${this.$store.state.proveedorUrl}profile`;
                const response = await this.sendRequest(URL, this.form, "PATCH", false);
                if (response.success) {
                    this.showSuccessMessage(response.message);
                    this.$store.commit('updateUser', this.form);
                    this.$emit("save", this.form);
                    this.close();
                }
            } catch (error) {
                console.error("Error al enviar la factura:", error);
            } finally {
                this.closeLoader();
            }
        },
        close() {
            this.dialog = false;
        },
        async getBancos() {
            this.openLoader();
            const URL = `${this.$store.state.proveedorUrl}catalogos/bancos`;
            const { data } = await this.sendRequest(URL);
            this.bancos = data;
            this.closeLoader();
        }
    }
};
</script>
